import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import Header from './Header';
import Navbar from './Navbar';
import { useLocation, useNavigate } from 'react-router-dom';

const Form = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);

     // Redirect if accessed directly without job role
     if (!location.state?.role) {
      navigate('/careers');
    }
  }, [location.state, navigate]);
  
  const initialRole = location.state?.role || '';
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    phoneNumber: '',
    emailId: '',
    role: initialRole,
    highestQualification: '',
    collegeName: '',
    branchName: '',
    universityId: '',
    linkedinId: '',
    attachment: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'attachment' && files.length > 0) {
      setFormData({ ...formData, attachment: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }
  
    try {
      const res = await fetch("/api/form", {
        method: "POST",
        body: form,
      });
  
      if (res.ok) {
        alert("Registration successful!");
        setFormData({
          name: '',
          dateOfBirth: '',
          phoneNumber: '',
          emailId: '',
          role: '',
          highestQualification: '',
          collegeName: '',
          branchName: '',
          universityId: '',
          linkedinId: '',
          attachment: null
        });
      } else {
        alert("Failed to register.");
      }
    } catch (err) {
      console.error(err);
      alert("Error occurred.");
    }
  };
  

  return (
    <div>
        <Header />
        <Navbar />

        <div className="font-sans">
          <section className="p-4 py-10 bg-gray-200">
            <div className="max-w-xl mx-auto bg-white p-5 mt-5 mb-5 rounded-lg shadow-md relative">
              <div className="">
                <h2 className="text-4xl font-bold text-center mb-6 mt-6 text-[#07294d]">Apply Now</h2>
                
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="name" className="block mb-1 font-bold text-[#535967]">
                      Name: *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      pattern="^[A-Za-z\s]+$"
                      title="Only alphabets and spaces are allowed"
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="dateOfBirth" className="block mb-1 font-bold text-[#535967]">
                      Date of Birth: *
                    </label>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      required
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="phoneNumber" className="block mb-1 font-bold text-[#535967]">
                      Phone Number: *
                    </label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      pattern="^\d{10}$"
                      title="Enter a 10-digit phone number"
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="emailId" className="block mb-1 font-bold text-[#535967]">
                      Email ID: *
                    </label>
                    <input
                      type="email"
                      id="emailId"
                      name="emailId"
                      value={formData.emailId}
                      onChange={handleChange}
                      required
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4 hidden">
                    <label htmlFor="role" className="block mb-1 font-bold text-[#535967]">
                      Role: *
                    </label>
                    {formData.role ? (
                      <input
                        type="text"
                        id="role"
                        name="role"
                        value={formData.role}
                        readOnly
                        className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                      />
                    ) : (
                      <select
                        id="role"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        required
                        className="w-full p-2 border border-gray-300 rounded-md"
                      >
                        <option value="" disabled>Select your role</option>
                        <option value="Network Security Engineer">Network Security Engineer</option>
                        <option value="Cybersecurity Analyst">Cybersecurity Analyst</option>
                        <option value="Aerospace Engineer">Aerospace Engineer</option>
                        <option value="Electrical & Electronics Engineer">Electrical & Electronics Engineer</option>
                        <option value="Software Developer">Software Developer</option>
                      </select>
                    )}
                  </div>

                  <div className="mb-4">
                    <label htmlFor="highestQualification" className="block mb-1 font-bold text-[#535967]">
                      Highest Qualification Degree: *
                    </label>
                    <input
                      type="text"
                      id="highestQualification"
                      name="highestQualification"
                      value={formData.highestQualification}
                      onChange={handleChange}
                      required
                      pattern="^[A-Za-z\s]+$"
                      title="Only alphabets and spaces are allowed"
                      placeholder="E.g., B.Tech, MCA, Ph.D."
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="collegeName" className="block mb-1 font-bold text-[#535967]">
                      College Name: *
                    </label>
                    <input
                      type="text"
                      id="collegeName"
                      name="collegeName"
                      value={formData.collegeName}
                      onChange={handleChange}
                      required
                      pattern="^[A-Za-z\s]+$"
                      title="Only alphabets and spaces are allowed"
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="branchName" className="block mb-1 font-bold text-[#535967]">
                      Branch Name: *
                    </label>
                    <input
                      type="text"
                      id="branchName"
                      name="branchName"
                      value={formData.branchName}
                      onChange={handleChange}
                      required
                      pattern="^[A-Za-z\s]+$"
                      title="Only alphabets and spaces are allowed"
                      placeholder="E.g., Computer Science, Electronics"
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="universityId" className="block mb-1 font-bold text-[#535967]">
                      University ID: *
                    </label>
                    <input
                      type="text"
                      id="universityId"
                      name="universityId"
                      value={formData.universityId}
                      onChange={handleChange}
                      required
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="linkedinId" className="block mb-1 font-bold text-[#535967]">
                      LinkedIn ID:
                    </label>
                    <input
                      type="text"
                      id="linkedinId"
                      name="linkedinId"
                      value={formData.linkedinId}
                      onChange={handleChange}
                      placeholder="Enter your LinkedIn profile URL"
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="attachment" className="block mb-1 font-bold text-[#535967]">
                      Upload Attachment: * (.pdf, up to 10MB)
                    </label>
                    <input
                      type="file"
                      id="attachment"
                      name="attachment"
                      onChange={handleChange}
                      accept=".pdf"
                      required
                      className="w-full p-2 border border-gray-300 rounded-md file:text-black file:mr-4 file:border-1 file:border-gray-300 file:bg-[#efefef] file:px-4 file:py-2 file:text-sm file:font-medium hover:file:bg-indigo-100"
                    />
                    <p className="text-xs text-gray-500 mt-1">Maximum file size: 10MB</p>
                  </div>
                  
                  <button
                    type="submit"
                    className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 cursor-pointer"
                  >
                    Register
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
        
        <Footer />
    </div>
  )
}

export default Form